import type { Transition, Variant, Variants } from 'framer-motion';

import { itemsPerRow, itemSize, itemGap, listWidth } from './tokens';

export enum InlineInputVariant {
    Initial = 'initial',
    Show = 'show',
    Exit = 'exit',
}

export function getInlineInputVariants(itemIndex: number): Variants {
    // Subtracting `2` since it is a `0`-based index
    // and we are off-setting against the leading `MultiStateAction`.
    const firstRow = itemIndex <= itemsPerRow - 2;
    const indexOffset = firstRow ? itemIndex + 1 : itemIndex - (itemsPerRow - 1);

    const itemWithGap = itemSize + itemGap;

    const positionTop = firstRow ? 0 : itemWithGap;
    const positionLeftStart = itemSize * indexOffset + itemGap * indexOffset;

    const closedState: Variant = {
        top: positionTop,
        left: positionLeftStart,
        right: listWidth - (positionLeftStart + itemSize),
    };

    return {
        [InlineInputVariant.Initial]: {
            ...closedState,
        },
        [InlineInputVariant.Show]: {
            top: positionTop,
            left: firstRow ? itemWithGap : 0,
            right: 0,
        },
        [InlineInputVariant.Exit]: {
            ...closedState,
            // Specify with keyframes so that the "fade-out"
            // occurs near the end of the "close" transition.
            opacity: [1, 1, 0],
        },
    };
}

export const inlineInputTransition: Transition = {
    type: 'spring',
    duration: 0.26,
    bounce: 0.1,
};

export const interiorTransition: Transition = {
    type: 'easeInOut',
    duration: 0.26,
};

// This "one-way fade" is needed to help mitigate a strange bug
// when expanding the <InlineInput />. If there is any visual
// whitespace on the left side of the <Interior /> (margin/padding/etc),
// it will be negatively offset until the <InlineInput /> has fully expanded.
// Extremely strange behaviour. I've tried many tricks to resolve it.
export const interiorVariants: Variants = {
    [InlineInputVariant.Initial]: {
        opacity: 0,
    },
    [InlineInputVariant.Show]: {
        opacity: 1,
    },
};

export const deleteActionVariants: Variants = {
    [InlineInputVariant.Initial]: {
        opacity: 0,
        translateX: 0,
    },
    [InlineInputVariant.Show]: {
        opacity: 1,
        translateX: '100%',
    },
};
